import { render, staticRenderFns } from "./FilteredInvoiceTbody.vue?vue&type=template&id=2c07dc30&scoped=true&"
import script from "./FilteredInvoiceTbody.vue?vue&type=script&lang=js&"
export * from "./FilteredInvoiceTbody.vue?vue&type=script&lang=js&"
import style0 from "./FilteredInvoiceTbody.vue?vue&type=style&index=0&id=2c07dc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07dc30",
  null
  
)

export default component.exports